import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Tuairiscigh an leathanach seo',
  title: 'Tuairiscigh fadhb leis an leathanach seo',
  reasons: {
    'inaccurate-or-fabricated': 'Faisnéis mhíchruinn nó chumtha',
    'wrong-product': 'Níl na táirgí ag teacht leis an leathanach',
    'sexually-explicit': 'Ábhar gnéasach follasach',
    'regulated-product': 'Táirge ar oideas nó faoi rialú',
    'dangerous-product': 'Táirge contúirteach',
    'ip-infringement': 'Sáraíonn sé mo chearta (trádmharc/cóipcheart)',
    other: 'Rud éigin eile',
  },
  detail: 'Sonraí (roghnach)',
  submit: 'Seol an tuairisc',
  cancel: 'Cealaigh',
  sent: 'Go raibh maith agat. Déanaimid athbhreithniú ar thuairiscí laistigh de 24 uair an chloig.',
  failed: 'Níorbh fhéidir an tuairisc a sheoladh. Bain triail eile as, le do thoil.',
};
